document.addEventListener("DOMContentLoaded", function () {
    const addToCartBtn = document.querySelector(".purchase-details__buttons");
    const stickyFooter = document.querySelector(".sticky-footer");
    const orderNowBtn = document.querySelector(".sticky-footer__button");
    const productName = document.querySelector(".product_name");
    const starRatings = document.querySelector(".jdgm-prev-badge__stars");

    if (!addToCartBtn || !stickyFooter) return;

    // Update product name in sticky footer
    if (productName) {
        document.querySelector(".sticky-footer__product-name").textContent = productName.textContent;
    }

    // Append star ratings if available
    if (starRatings) {
        document.querySelector(".sticky-footer__ratings").appendChild(starRatings.cloneNode(true));
    }

    function adjustChatButton(bottomValue) {
        const chatButton = document.querySelector("iframe#chat-button");
        if (chatButton) {
            chatButton.style.setProperty("bottom", bottomValue, "important");
        }
    }

    function toggleStickyFooter() {
        const addToCartPosition = addToCartBtn.getBoundingClientRect().top + window.scrollY;
        const scrollPosition = window.scrollY;

        if (scrollPosition > addToCartPosition) {
            stickyFooter.classList.add("show");
            adjustChatButton("155px");
        } else {
            stickyFooter.classList.remove("show");
            adjustChatButton("20px");
        }
    }

    // Wait for the chat button to load
    const chatObserver = new MutationObserver(() => {
        const chatButton = document.querySelector("iframe#chat-button");
        if (chatButton) {
            toggleStickyFooter();
            chatObserver.disconnect();
        }
    });

    chatObserver.observe(document.body, { childList: true, subtree: true });

    // Scroll listener
    window.addEventListener("scroll", toggleStickyFooter);

    // Click event to scroll to product form
    orderNowBtn.addEventListener("click", function (e) {
        e.preventDefault();
        const productForm = document.querySelector(".product_name");
        if (productForm) {
            productForm.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    });

    // Initial check in case page loads with footer already visible
    toggleStickyFooter();
});


(function () {
  function updateQaBadges(root = document) {
    root.querySelectorAll('span.jdgm-qa-badge__text').forEach(function (el) {
      if (el.textContent.trim().toLowerCase().includes('no questions')) {
        el.textContent = 'Ask a Question';
      }
    });
  }

  // Run once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateQaBadges);
  } else {
    updateQaBadges();
  }

  // Watch for async app renders (Judge.me, section loads, etc.)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        updateQaBadges(node); // re-check newly added nodes
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Shopify Theme Editor hot reload
  document.addEventListener('shopify:section:load', updateQaBadges);

  // Extra safety: brief poll for late renders
  var tries = 0,
    timer = setInterval(function () {
      updateQaBadges();
      if (++tries > 20) clearInterval(timer); // ~5s
    }, 250);
})();

